import { render, staticRenderFns } from "./admin_agent.vue?vue&type=template&id=3f905741&scoped=true&"
import script from "./admin_agent.vue?vue&type=script&lang=js&"
export * from "./admin_agent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f905741",
  null
  
)

export default component.exports